import type { QueryKey } from '@tanstack/react-query'

/**
 * Query families that a WebSocket runtime recovery cannot make stale.
 *
 * Level 1 still invalidates live/snapshot data so stream-backed screens can
 * recover from missed frames. Stable catalogs, user configuration, account
 * metadata, and AI/chat state are left untouched to avoid unrelated refetches
 * during the recovery burst.
 */
const RECOVERY_INVALIDATION_EXCLUDED_ROOTS = new Set([
  // Stable instrument catalogs.
  'instrument',
  'master-instrument',

  // Account metadata/configuration. Account stream data uses separate keys and atoms.
  'account-access',
  'accountExchanges',
  'accounts',

  // Dashboard/user settings.
  'billing',
  'uiState',
  'userProfile',
  'venues',

  // AI/chat UI state. service/ai-client.ts itself is Axios-based and has no query key.
  'keywords',
  'messages:should-scroll',
  'research',
  'session',
  'sessions',
])

export function shouldInvalidateForRuntimeRecovery(queryKey: QueryKey): boolean {
  const root = queryKey[0]
  return typeof root !== 'string' || !RECOVERY_INVALIDATION_EXCLUDED_ROOTS.has(root)
}
